import { render } from "./OriginatorRewards.vue?vue&type=template&id=06b0eebc&scoped=true"
import script from "./OriginatorRewards.vue?vue&type=script&lang=js"
export * from "./OriginatorRewards.vue?vue&type=script&lang=js"

import "./OriginatorRewards.vue?vue&type=style&index=0&id=06b0eebc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b0eebc"]])

export default __exports__